var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgNumberStatus01 = function SvgNumberStatus01(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    "data-name": "Layer 1",
    viewBox: "0 0 200 200",
    focusable: false,
    "aria-hidden": true
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "number_status-01_svg2__a",
    x1: -29.74,
    x2: 127.41,
    y1: 134.4,
    y2: -22.75,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff3fe5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#f434e5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#dd1de7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#cd0ce8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#c403e8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c100e9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#number_status-01_svg2__a",
    id: "number_status-01_svg2__b",
    x1: 52.93,
    x2: 210.08,
    y1: 217.07,
    y2: 59.92
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#number_status-01_svg2__a",
    id: "number_status-01_svg2__c",
    x1: -14.48,
    x2: 142.67,
    y1: 149.66,
    y2: -7.49
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#number_status-01_svg2__a",
    id: "number_status-01_svg2__d",
    x1: 33.97,
    x2: 191.12,
    y1: 198.11,
    y2: 40.96
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M73.97 13.79c-2.07 0-3.45 1.38-3.45 3.45s1.38 3.45 3.45 3.45h26.9c2.07 0 3.45-1.38 3.45-3.45s-1.38-3.45-3.45-3.45z",
    style: {
      fill: "url(#number_status-01_svg2__a)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.97 179.31H80.52c-2.07 0-3.45 1.38-3.45 3.45s1.38 3.45 3.45 3.45h13.45c2.07 0 3.45-1.38 3.45-3.45s-1.38-3.45-3.45-3.45",
    style: {
      fill: "url(#number_status-01_svg2__b)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.62 93.1c2.07 0 3.45-1.38 3.45-3.45V20.34c0-7.24 5.52-13.45 13.1-13.45h74.14c7.24 0 13.1 6.21 13.1 13.45v62.41c-.34 2.07 1.38 3.45 3.1 3.45 2.07.01 3.45-1.37 3.45-3.44V20.34c0-11.03-8.62-20.34-20-20.34H50.17c-11.03 0-20 9.31-20 20.34v69.31c0 2.07 1.38 3.45 3.45 3.45",
    style: {
      fill: "url(#number_status-01_svg2__c)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.72 100h-35.17l-2.76-14.48c-.34-1.72-1.72-2.76-3.45-2.76s-3.1 1.03-3.45 2.76l-5.52 29.66-4.83-60.34c0-2.07-1.72-3.45-3.79-3.1-1.38 0-2.76 1.03-3.1 2.41l-15.17 47.93-6.55-10.69c-.34-1.03-1.38-1.72-2.41-1.72s-2.41.69-3.1 1.38l-5.86 8.97H33.28c-2.07 0-3.45 1.38-3.45 3.45v76.21h.34v-.02c0 11.03 8.62 20.34 20 20.34h74.14c11.03 0 20-9.31 20-20.34V106.9h22.41c2.07 0 3.45-1.38 3.45-3.45s-1.38-3.45-3.45-3.45m-29.64 79.29c0 7.24-5.52 13.45-13.1 13.45H50.17c-7.24 0-13.1-6.21-13.1-13.45v-72.41h36.21v.02c1.03 0 2.07-.69 2.76-1.38l3.79-5.86 7.59 12.41c1.03 1.72 3.1 2.07 4.83 1.03.69-.34 1.38-1.03 1.38-2.07l12.07-38.28 5.52 68.62c0 1.72 1.38 3.1 3.1 3.1h.34c1.72 0 3.1-1.03 3.45-2.76l6.9-37.59c.34 1.38 1.72 2.41 3.45 2.41h8.62z",
    style: {
      fill: "url(#number_status-01_svg2__d)"
    }
  }));
};
export default SvgNumberStatus01;